export enum ROLES {
  PHYSICIAN_OVERSIGHT = 'physician_oversight',
  AUDIT_TRAIL = 'audit_trail',
  USER_TRACKER = 'user_tracker',
  SUPPORT = 'support',
}
